var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10.25C19.6875 4.9375 15.3125 0.5625 10 0.5625C4.64844 0.5625 0.3125 4.9375 0.3125 10.25C0.3125 15.6016 4.64844 19.9375 10 19.9375C15.3125 19.9375 19.6875 15.6016 19.6875 10.25ZM8.86719 15.4062C8.63281 15.6406 8.20312 15.6406 7.96875 15.4062L3.90625 11.3438C3.67188 11.1094 3.67188 10.6797 3.90625 10.4453L4.80469 9.58594C5.03906 9.3125 5.42969 9.3125 5.66406 9.58594L8.4375 12.3203L14.2969 6.46094C14.5312 6.1875 14.9219 6.1875 15.1562 6.46094L16.0547 7.32031C16.2891 7.55469 16.2891 7.98438 16.0547 8.21875L8.86719 15.4062Z",
    fill: "#0F43F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.52700a89f572a89cdfe12907ef284ffa.svg";
export { ForwardRef as ReactComponent };